import { SvgIcon, SvgIconProps } from "@mui/material";

const SendIcon = (props: SvgIconProps) => (
	<SvgIcon viewBox="0 0 33 33" {...props}>
		<path
			d="M13.6662 19.7767L31.9995 1.44336M13.6662 19.7767L19.4996 31.4434C19.5728 31.6029 19.6902 31.7381 19.8379 31.8329C19.9856 31.9278 20.1574 31.9781 20.333 31.9781C20.5085 31.9781 20.6803 31.9278 20.828 31.8329C20.9758 31.7381 21.0932 31.6029 21.1663 31.4434L31.9995 1.44336M13.6662 19.7767L1.99963 13.9434C1.84006 13.8702 1.70484 13.7528 1.61004 13.6051C1.51524 13.4574 1.46484 13.2856 1.46484 13.11C1.46484 12.9345 1.51524 12.7627 1.61004 12.6149C1.70484 12.4672 1.84006 12.3498 1.99963 12.2767L31.9995 1.44336"
			stroke="#5300C9"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			fill="none"
		/>
	</SvgIcon>
);

export default SendIcon;
